import * as e from "react";
import c from "../lib/IconBase.es.js";
import r from "../defs/LockSimpleOpen.es.js";
const o = e.forwardRef((m, p) => /* @__PURE__ */ e.createElement(c, { ref: p, ...m, weights: r }));
o.displayName = "LockSimpleOpenIcon";
const a = o;
export {
  a as LockSimpleOpen,
  o as LockSimpleOpenIcon
};
